import React, { useState, useEffect } from 'react';

const ProgressBarPercentage = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate progress update
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 60) {
          clearInterval(interval);
          return 60;
        }
        return prevProgress + 10;
      });
    }, 500);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <div>
        {/* Title */}
        <h6 className="f-12 mb-1">Profile</h6>

        {/* Progress Bar */}
        <div className="progress" style={{ height: '10px', borderRadius: '20px' }}>
            <div
                className="progress-bar bg-primary f-10"
                role="progressbar"
                style={{ width: `${progress}%` }}
                aria-valuenow={progress}
                aria-valuemin={0}
                aria-valuemax={100}
                >
                {progress}%
            </div>
        </div>
    </div>
  );
};

export default ProgressBarPercentage;